import { breakingNews } from "@/mocks/baoliaoData";

export default function BreakingTicker() {
  const items = [...breakingNews, ...breakingNews];
  return (
    <div className="bg-foreground-950 text-background-100 overflow-hidden border-b border-background-200/60">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 flex items-stretch h-10">
        <div className="flex items-center gap-1.5 pr-3 md:pr-4 shrink-0 border-r border-background-100/15">
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-live"></span>
          <span className="font-heading font-extrabold text-xs md:text-sm tracking-wider text-background-50">
            实时热点
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden mask-image">
          <div className="flex items-center whitespace-nowrap animate-ticker h-10">
            {items.map((text, i) => (
              <span key={i} className="inline-flex items-center text-xs md:text-[13px] text-background-100/90">
                <i className="ri-fire-fill text-primary-500 mx-2.5"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#live"
          className="hidden md:flex items-center gap-1 pl-3 ml-auto shrink-0 text-xs font-medium text-accent-300 hover:text-accent-200 whitespace-nowrap"
        >
          去实时爆料 <i className="ri-arrow-right-line text-xs"></i>
        </a>
      </div>
    </div>
  );
}